import React from 'react';
import globalGetPadding from '../../utils/getPadding';
import { getBorderRadiusValue } from '../../utils/borderRadius';

function getBorder(style) {
    if (!style || !style.borderColor) {
        return undefined;
    }
    return `1px solid ${style.borderColor}`;
}

export function CustomContainer({ fullWidthOnMobile, style, layoutStyle, children }) {
    const isMobile = fullWidthOnMobile <= 480;
    const currentPadding = globalGetPadding(style?.padding, isMobile);
    const c_padding_num = currentPadding.replaceAll('px', '');
    const c_padding_array = c_padding_num.split(' ');
    const l_r_padding = Number(c_padding_array[1]) + Number(c_padding_array[3]);
    const boxShadow = style?.boxShadow ? 
        `${style?.boxShadow?.offsetX ?? 0}px ${style?.boxShadow?.offsetY ?? 0}px ${style?.boxShadow?.blur ?? 0}px ${style?.boxShadow?.spread ?? 0}px ${style?.boxShadow?.color ?? 'transparent'}`
         : undefined;
    const wStyle = {
        width: style?.width ? `min(${style?.width+style?.widthUnit}, calc(100% - ${l_r_padding}px))` : 'unset',
        height: style?.fillHeight ? '100%' : undefined,
        boxSizing: 'border-box',
        display: 'grid',
        alignItems: !style?.alignVertical ? 'unset' : style?.alignVertical,
        justifyItems: !style?.alignHorizontal || style?.alignHorizontal === 'start' ? 'stretch' : style?.alignHorizontal,
        margin: style.alignHorizontal === 'center' ? '0 auto' : '',
        backgroundColor: style?.backgroundColor ?? undefined,
        border: getBorder(style),
        borderRadius: getBorderRadiusValue(style?.borderRadius),
        padding: currentPadding,
        boxShadow: boxShadow,
        ...layoutStyle,
    };
    if (!children) {
        return <div style={wStyle} />;
    }
    return <div style={wStyle}>{children}</div>;
}

